import { Booking } from "../../../../APIDocs/apiTypes"
import { CollapsibleCard } from "../../components/CollapsibleCard";
import { Label } from "../../components/Label";
import { useIsInternalUser } from "../../hooks/useUserPermissions";

interface FieldDetailsProps {
    booking: Booking
    disableCollapse?: boolean
}

export const FieldDetailsCard = ({ booking, disableCollapse }: FieldDetailsProps) => {
    const isInternalUser = useIsInternalUser();
    const renderOutcomeForJob = booking.BookingOutcome != undefined && booking.BookingOutcome.Description != undefined && booking.BookingOutcome.Description != '';

    if (Object.values(booking.FieldDetails ?? {}).length === 0 && !renderOutcomeForJob) return null

    return (
        <CollapsibleCard identifier="fieldDetails" title="Field Details" disableCollapse={disableCollapse}>
            <div className="grid grid-cols-3">
                <Label title="Field Receipt Status" text={booking.FieldDetails?.FieldReceiptStatus} />
                <Label title="Field Receipt Status Date" text={booking.FieldDetails?.FieldReceiptStatusDate} />
                <Label title="Visit Outcome" text={booking.FieldDetails?.VisitOutcome} />
                <Label title="Actual Visit Date Time" text={booking.FieldDetails?.ActualVisitDateTime} />
                {renderOutcomeForJob && <Label title="Booking Outcome" text={booking.BookingOutcome?.Description} />}
                {isInternalUser && <Label title="Field Comments" text={booking.FieldDetails?.FieldComments} className="col-span-full" />}
                {isInternalUser && <Label title="Tech Notes" text={booking.FieldDetails?.TechNotes} className="col-span-full" />}
            </div>
        </CollapsibleCard>
    )
}
